import {
    NextButtonV2,
    PrevButtonV2,
} from '@components/Homepage/OpportunitiesCarousel/CarouselArrowButtons';
import { useRouter } from 'next/router';
import { triggerCustomGaEvent } from '@helpers/miscelleanous';
import { homepageGaEventName } from '@helpers/ga-events-name-enum';
import useWindowDimensions from '@hooks/useWindowDimensions';
import useEmblaCarousel from 'embla-carousel-react';
import OpportunityCarouselCard from './OpportunityCarouselCard';
import routes from '@helpers/routes';
import { useCallback, useEffect, useState } from 'react';

const OpportunitiesCarouselSection = ({
    isHomePage = true,
    isLogged,
    opportunities,
    customOnClick,
}) => {
    const { width } = useWindowDimensions();
    const [emblaRef, emblaApi] = useEmblaCarousel({
        loop: true,
        align: width < 1280 ? 'center' : 'start',
        draggable: true,
        containScroll: 'trimSnaps',
    });
    const router = useRouter();
    const scrollPrev = () => emblaApi && emblaApi.scrollPrev();
    const scrollNext = () => emblaApi && emblaApi.scrollNext();
    const [activeSlide, setActiveSlide] = useState(0);

    const onSelect = useCallback(() => {
        if (!emblaApi) return;
        setActiveSlide(emblaApi.selectedScrollSnap());
    }, [emblaApi]);

    useEffect(() => {
        if (!emblaApi) return;
        emblaApi.on('select', onSelect);
    }, [emblaApi]);

    const handleOnClick = (opportunity) => {
        const { opportunityId, canInvest } = opportunity;
        if (customOnClick) {
            customOnClick(opportunityId, canInvest);
            return;
        }

        if (canInvest)
            triggerCustomGaEvent(
                isHomePage
                    ? homepageGaEventName.CLICKED_INVEST_NOW_DEAL_HOME_PAGE
                    : homepageGaEventName.CLICKED_INVEST_NOW_DEAL_SIGNUP_PAGE
            );
        else
            triggerCustomGaEvent(
                isHomePage
                    ? homepageGaEventName.CLICKED_VIEW_OPPORTUNITY_DEAL_HOME_PAGE
                    : homepageGaEventName.CLICKED_VIEW_OPPORTUNITY_DEAL_SIGNUP_PAGE
            );

        if (isLogged) router.push(`/opportunity/${opportunityId}`);
        else router.push(routes.bonds.byIsin(opportunity?.isin));
    };
    const slideCount = emblaApi?.slideNodes()?.length;
    const leftOfCenterIndex = (activeSlide - 1 + slideCount) % slideCount;
    const rightOfCenterIndex = (activeSlide + 1) % slideCount;

    return (
        <div className="relative w-full">
            <div className="relative xl:w-[1032px] xl:mx-auto">
                <div
                    className="pb-2 sm:pb-6 xl:pb-10 overflow-hidden pt-6 xl:pt-10"
                    ref={emblaRef}
                    aria-label="Opportunities Carousel"
                >
                    <div className="flex sm:gap-4 xl:gap-6">
                        {opportunities.map((details, index) => {
                            const isLeft = index === leftOfCenterIndex;
                            const isRight = index === rightOfCenterIndex;

                            return (
                                <div
                                    className={`min-w-[328px] ${
                                        index === 0 ? 'sm:ml-4 xl:ml-6' : ''
                                    }
                                    ${isLeft ? 'mr-[-32px] sm:mr-auto' : ''} ${
                                        isRight
                                            ? activeSlide ===
                                              opportunities.length - 1
                                                ? ''
                                                : 'ml-[-32px] sm:ml-auto'
                                            : ''
                                    }
                                    
                                    `}
                                >
                                    <OpportunityCarouselCard
                                        key={index}
                                        details={details}
                                        opportunity={details}
                                        index={index}
                                        handleOnClick={handleOnClick}
                                    />
                                </div>
                            );
                        })}
                    </div>
                </div>
                <PrevButtonV2
                    className="absolute left-[-80px] top-1/2 transform -translate-y-1/2 hidden xl:inline-block"
                    onClick={scrollPrev}
                />
                <NextButtonV2
                    className="absolute right-[-80px] top-1/2 transform -translate-y-1/2 hidden xl:inline-block"
                    onClick={scrollNext}
                />
            </div>
            <div className="flex items-center justify-center gap-6 xl:hidden">
                <PrevButtonV2
                    className="inline-block xl:hidden"
                    onClick={scrollPrev}
                    isMobile
                />
                <NextButtonV2
                    className="inline-block xl:hidden"
                    onClick={scrollNext}
                    isMobile
                />
            </div>
        </div>
    );
};
export default OpportunitiesCarouselSection;
